export const GET_PROJECT_PROPERTIES = "GET_PROJECT_PROPERTIES";
